module.exports = __webpack_public_path__ + "static/media/apercu-regular.527acf39.woff2";